const password = (state = "", action) => {
    switch(action.type) {
        case 'password':
            return action.payload;
        default:
            return state;
    }
}

export default password;